import barista1 from '../images/barista1.png';
import barista2 from '../images/barista2.jpg';

export const baristas = [
	{
		img: barista1,
		alt: 'Barista',
		name: 'Anastasia',
		detail: 'Say hi to Anastasia! You might have seen her around the cafe. Probably serving you coffee. Ana is the newest member of the Tarpit team. She rides, she codes, she is a founder of motorcycle commmunities Cool Club Moto NYC and Moto Baes NYC. And of course, she makes excellent coffee!'
	},
	{
		img: barista2,
		alt: 'Barista',
		name: 'Elya',
		detail:'Elya has been with us for 4 years now! She is an amazing baker and artist. Multi-talented artist. Look out for her delicious vegan cakes on the weekends.'
	},
];